/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureImplant from './patient-procedure-implant';
import PatientProcedureImplantDetail from './patient-procedure-implant-detail';
import PatientProcedureImplantUpdate from './patient-procedure-implant-update';
import PatientProcedureImplantDeleteDialog from './patient-procedure-implant-delete-dialog';

const PatientProcedureImplantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureImplant />} />
    <Route path="new" element={<PatientProcedureImplantUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureImplantDetail />} />
      <Route path="edit" element={<PatientProcedureImplantUpdate />} />
      <Route path="delete" element={<PatientProcedureImplantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureImplantRoutes;
